module.exports = __webpack_public_path__ + "static/36-86fd4de8d033fbf1687c17358fc236df.png";